interface Props {
  className?: string;
}

const PhoneIconFilled = ({ className, ...rest }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    className={className || "w-5 h-5"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M5.48 14.486C2.362 11.384 0 7.636 0 4.545 0 3.177.464 1.939 1.51.937 2.147.323 2.88 0 3.592 0c.583 0 1.111.226 1.489.743L7.4 4.006c.355.507.539.927.539 1.314 0 .496-.292.927-.766 1.422l-.766.786a.54.54 0 0 0-.162.399c0 .161.065.312.119.43.345.668 1.326 1.81 2.384 2.865 1.068 1.056 2.211 2.036 2.88 2.391.108.054.27.119.431.119.14 0 .292-.054.41-.172l.766-.754c.496-.485.939-.765 1.424-.765.389 0 .81.172 1.316.517l3.312 2.348c.507.366.712.883.712 1.421 0 .733-.356 1.476-.928 2.111-.981 1.077-2.2 1.562-3.592 1.562-3.096 0-6.882-2.402-10-5.514"
    />
  </svg>
);

export default PhoneIconFilled;
